export default "__VITE_ASSET__aIAXhcCM__"